var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.offer.parts, function(part, partIndex) {
      return _c(
        "v-row",
        { key: part },
        [
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { md: "3", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.$t("travelService.hotelName"),
                  filled: "",
                  readonly: ""
                },
                model: {
                  value: part.name,
                  callback: function($$v) {
                    _vm.$set(part, "name", $$v)
                  },
                  expression: "part.name"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { md: "3", cols: "12" } },
            [
              _c("v-rating", {
                staticClass: "small-rating",
                attrs: { readonly: "" },
                model: {
                  value: part.hotel_class,
                  callback: function($$v) {
                    _vm.$set(part, "hotel_class", $$v)
                  },
                  expression: "part.hotel_class"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { md: "6", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.$t("travelService.address"),
                  filled: "",
                  readonly: ""
                },
                model: {
                  value: part.address,
                  callback: function($$v) {
                    _vm.$set(part, "address", $$v)
                  },
                  expression: "part.address"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.$t("travelService.accommodationDate"),
                  filled: "",
                  readonly: ""
                },
                model: {
                  value: part.start_date,
                  callback: function($$v) {
                    _vm.$set(part, "start_date", $$v)
                  },
                  expression: "part.start_date"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.$t("travelService.outDate"),
                  filled: "",
                  readonly: ""
                },
                model: {
                  value: part.end_date,
                  callback: function($$v) {
                    _vm.$set(part, "end_date", $$v)
                  },
                  expression: "part.end_date"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.$t("travelService.numberOfPeoplePerRoom"),
                  filled: "",
                  readonly: ""
                },
                model: {
                  value: part.person_per_room,
                  callback: function($$v) {
                    _vm.$set(part, "person_per_room", $$v)
                  },
                  expression: "part.person_per_room"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.$t("travelService.roomCount"),
                  filled: "",
                  readonly: ""
                },
                model: {
                  value: part.rooms,
                  callback: function($$v) {
                    _vm.$set(part, "rooms", $$v)
                  },
                  expression: "part.rooms"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.$t("travelService.roomType"),
                  filled: "",
                  readonly: ""
                },
                model: {
                  value: part.room_type,
                  callback: function($$v) {
                    _vm.$set(part, "room_type", $$v)
                  },
                  expression: "part.room_type"
                }
              })
            ],
            1
          ),
          part.additional_services != null &&
          part.additional_services.toString().length > 0
            ? _c(
                "v-col",
                { staticClass: "pa-1", attrs: { md: "4", cols: "12" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      label: _vm.$t("travelService.additionalServices"),
                      filled: "",
                      readonly: ""
                    },
                    model: {
                      value: part.additional_services,
                      callback: function($$v) {
                        _vm.$set(part, "additional_services", $$v)
                      },
                      expression: "part.additional_services"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          part.price_per_day != null && part.price_per_day.toString().length > 0
            ? _c(
                "v-col",
                { staticClass: "pa-1", attrs: { md: "4", cols: "12" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      label: _vm.$t("travelService.averagePricePerDay"),
                      filled: "",
                      readonly: ""
                    },
                    model: {
                      value: part.price_per_day,
                      callback: function($$v) {
                        _vm.$set(part, "price_per_day", $$v)
                      },
                      expression: "part.price_per_day"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.$t("travelService.freeCancelUntil"),
                  placeholder: _vm.$t("travelService.noFreeCancel"),
                  filled: "",
                  readonly: ""
                },
                model: {
                  value: part.cancel_until,
                  callback: function($$v) {
                    _vm.$set(part, "cancel_until", $$v)
                  },
                  expression: "part.cancel_until"
                }
              })
            ],
            1
          ),
          part.comment != null && part.comment.length > 0
            ? _c(
                "v-col",
                { staticClass: "pa-1", attrs: { cols: "12" } },
                [
                  _c("v-textarea", {
                    attrs: {
                      label: _vm.$t("travelService.travelAgentComment"),
                      filled: "",
                      readonly: ""
                    },
                    model: {
                      value: part.comment,
                      callback: function($$v) {
                        _vm.$set(part, "comment", $$v)
                      },
                      expression: "part.comment"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          partIndex < _vm.offer.parts.length - 1
            ? _c("v-col", { attrs: { cols: "12" } }, [_c("v-divider")], 1)
            : _vm._e()
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }